<header class="header-main">
  <nav class="navbar navbar-expand-lg navbar-light rounded-bottom " id="navbar-claro">
    <div class="container  justify-content-center">
      <!-- <h4 class="p-2">Claro CENAM</h4> -->
      <!-- <img src="../../../../assets/images/Superapp claro.png" class="p-2" alt="" href="https://www.claro.com.co/personas/"> -->
    </div>
  </nav>
</header>
